import { SingleSelectWithOther } from '@strata/react-compound-inputs';
import { DialogWithForm } from '@strata/react-dialog';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

const NoteOptions = [
    'Research Required',
    'Provider Outreach',
    'Pharmacy Outreach',
    'Client Escalation',
    'Pharmacy Escalation',
    'Updated Member Information',
    'Updated Provider Information',
    'Tracking Information',
    'Therapy Discontinuation/Switch',
    'Update Referral Information',
    'Claim Processing Issue',
    'Referral Setback',
    'Fill under alternate member id',
    'Fill under alternate oid',
    'Patient inbound phone call',
    'NDP',
    'Prescriber inbound phone call',
    'Prescriber email',
    'Patient email',
    'Complaint tracking',
    'Referral Assignment on Hold',
    'Bug Submitted',
    'Polypharmacy Review',
    'Duplicate Therapy Review',
    'IRX Pharmacy Outreach',
    'Pharmacy inbound phone call',
];

export const NewNoteDialog = ({ isOpen = false, onCreate, onCancel }) => (
    <Formik
        initialValues={SingleSelectWithOther.initialValues({ id: 'subject' })}
        onSubmit={(values, { resetForm }) => {
            onCreate(SingleSelectWithOther.submitValues({ id: 'subject' })(values));
            resetForm();
        }}
        validationSchema={Yup.object(
            SingleSelectWithOther.validationSchema({ id: 'subject', required: true }),
        )}
        enableReinitialize
    >
        {(formik) => (
            <DialogWithForm
                isOpen={isOpen}
                dialogTitle="Create Notebook"
                isPrimaryButtonDisabled={!(formik.dirty && formik.isValid)}
                onSecondaryButtonClick={() => {
                    onCancel();
                    formik.resetForm();
                }}
                primaryButtonLabel="Create Notebook"
                secondaryButtonLabel="Cancel"
                dialogContent={
                    <SingleSelectWithOther
                        id="subject"
                        label="Notebook Title"
                        required
                        values={NoteOptions}
                    />
                }
            />
        )}
    </Formik>
);

NewNoteDialog.propTypes = {
    isOpen: PropTypes.bool,
    onCreate: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
